{
    "DisplayasoptionsGrid": "Netz",
    "DisplayasoptionsColumns": "Säulen",
    "DisplayasoptionsRows": "Reihen",
    "DisplayasoptionsChart": "Diagramm",
    "DisplayasoptionsDetailedtableview": "Detaillierte Tabellenansicht",
    "DisplayasoptionsBlfviewhorizontal": "BLF-Ansicht (horizontal)",
    "DisplayasoptionsBlfviewvertical": "BLF-Ansicht (vertikal)",
    "DisplayasoptionsChartview": "Diagrammansicht",
    "NAME": "DisplayedAsOptions"
}